/* @sravni/react-design-system version 0.2.50 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_a3dacc96 from '../styles/List.module.less.js';

/**
 * @description List item element.
 *
 * @component
 * @example
 * ```jsx
 * <ListItem>...</ListItem>
 * ```
 */
var ListItem = React.forwardRef(function (props, ref) {
    var icon = props.icon, className = props.className, children = props.children, restProps = __rest(props, ["icon", "className", "children"]);
    var cx = useStyles(modules_a3dacc96);
    var classNames = cx(className, 'item', {
        'with-icon': icon,
    });
    return (React.createElement("li", __assign({ ref: ref, className: classNames }, restProps),
        icon ? React.createElement("span", { className: cx('icon') }, icon) : null,
        children));
});

export { ListItem };
//# sourceMappingURL=ListItem.js.map
